import { useEffect,useState } from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { post } from '../../utils/axios'
import Phone from '@mui/icons-material/Phone'

const ContactUs = () => {

    const [content,setContent] = useState([])

    useEffect(() => {
        const postedData = {
            key: 'contactus'
        }
        post('Config/GetConfigByKey',postedData).then(({ data }) => {
            if(data.isSuccess){
                const contactData = data.data.value.split('\n')
                const contentData = []
                contactData.map(item => {
                    if(item)
                        contentData.push(item)
                })
                setContent(contentData)
            }
        })
    },[])

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">تماس با ما</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 5 }} className="business-item contact-detail-parent">
                    <CardContent style={{ paddingBottom: 16 }}>
                        {content.map((contact,index) => <>
                            <p key={index} className="others-page-content" style={{ position: 'relative' }}>
                                {contact}
                                {/^-?\d+$/.test(contact.toString().split(':')[1].replace(')','').replace('(','').replace('+','').trim()) && !contact.toString().split(':')[1].includes('-') ? <a className="phone-icon-action" href={`tel:${contact.toString().split(':')[1].replace(')','').replace('(','').replace('+','').trim()}`}><Phone /></a> : ''}
                            </p>
                        </>)}
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default ContactUs